var kind       = require("enyo/kind"),
    CoreObject = require("enyo/CoreObject");

/**
 * [Scalar]{@link enyo-anim.Scalar} is parameter that can be animated. It stores
 * the parameters' value as well as acceleration and velocity.
 *
 * For the sake of performance, we don't implement any type checking. Please
 * supply the parameters within the documented types and ranges.
 *
 * @class   enyo-anim.Scalar
 * @extends enyo.Object
 * @public
 */
module.exports = kind(/** @lends enyo-anim.Scalar.prototype */ {

    /**
     * @private
     */
    name: "enyo-anim.Scalar",

    /**
     * @private
     */
    kind: CoreObject,

    /**
     * Current value.
     *
     * @type    {?number}
     * @default null
     * @public
     */
    value: null,

    /**
     * The lowest significant change in value. (Used to break zeno's paradox)
     * Must be greater than 0.
     *
     * @type    {number}
     * @default 0.02
     * @public
     */
    epsilon: 0.02,

    /**
     * Friction multiplier. Value of 1 means no friction, value of 0 is instant
     * dead-stop.
     *
     * @type    {number}
     * @default 0.83
     * @public
     */
    friction: 0.83,

    /**
     * Current acceleration value
     *
     * @type    {number}
     * @default 0
     * @public
     */
    acceleration: 0,

    /**
     * Current velocity value
     *
     * @type    {number}
     * @default 0
     * @public
     */
    velocity: 0,

    /**
     * Multiply the value, velocity and acceleration.
     *
     * @param {number}  multiplier  The multiplier
     * @public
     */
    resize: function(multiplier) {
        var value = this.value;

        // Skip if multiplier is 1;
        if (multiplier !== 1) {
            this.value        = value !== null ? value * multiplier : value;
            this.velocity     *= multiplier;
            this.acceleration *= multiplier;
        }
    },

    /**
     * Sets value and clears any existing velocity or acceleration.
     *
     * @param {number}  value  The value
     * @public
     */
    snap: function(value) {
        this.value = value;
        this.stop();
    },

    /**
     * Leaves value intact but clears existing velocity and acceleration.
     *
     * @public
     */
    stop: function() {
        this.velocity     = 0;
        this.acceleration = 0;
    }

});
